if(!__webpack_require__.federation){
	__webpack_require__.federation = {
		initOptions: {"name":"_vk_cloud_lk_host","remotes":[{"alias":"@vk-cloud-lk/host","name":"_vk_cloud_lk_host","entry":"[@vk-cloud-lk/host]/bundle.js","shareScope":"default"}],"shareStrategy":"version-first"},
		chunkMatcher: function(chunkId) {return !/^(4(01|35|9)|1|158|571|777|809|946)$/.test(chunkId)},
		rootOutputDir: "",
		initialConsumes: undefined,
		bundlerRuntimeOptions: {}
	};
}